import * as types from '../dashboardActionTypes';

export default function systemStatusLoadingReducer(state = true, action) {
    switch (action.type) {
        case types.LOAD_SYSTEM_STATUS:
            return true;
        case types.LOAD_SYSTEM_STATUS_FAILED:
        case types.LOAD_SYSTEM_STATUS_SUCCESS:
            return false;
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/dashboard/reducers/systemStatusLoadingReducer.js